/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import { colors } from '../../../themes'
import TooltipPopupTip from '../TooltipPopupTip'

import styles from './styles'

const CancelledEventTooltipPopupTip = ({ content, trigger, triggerClassName, onOpen, useMediaQueryProp, position }) => (
  // Prevents parent anchor from redirecting to it's `href`
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <span
    onClick={ev => {
      ev.preventDefault()
    }}>
    <TooltipPopupTip
      color={colors.grayChateau}
      className={cx(styles.tip, triggerClassName)}
      trigger={trigger}
      content={content}
      onOpen={onOpen}
      useMediaQueryProp={useMediaQueryProp}
      position={position}
    />
  </span>
)

CancelledEventTooltipPopupTip.propTypes = {
  content: PropTypes.node.isRequired,
  trigger: PropTypes.func.isRequired,
  triggerClassName: PropTypes.string,
  onOpen: PropTypes.func,
  useMediaQueryProp: PropTypes.func,
  position: PropTypes.string,
}

export default CancelledEventTooltipPopupTip
